import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UtilsManager } from 'src/app/managers/utils/utils.manager';
import { ChartConfiguration, CustomColumn } from '../../table/custom-table/custom-table.component';

import * as d3 from 'd3-scale-chromatic';

import { Chart } from 'chart.js';

@Component({
  selector: 'cq-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.scss']
})
export class ChartsComponent implements OnInit {

  @Input()  conf              : ChartConfiguration
  @Input()  visibleColumns    : CustomColumn[]
  @Input()  unfilteredColumns : CustomColumn[]
  @Input()  rows              : any[]

  constructor(
    private _translate: TranslateService,
    private _utils    : UtilsManager
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){ }

  ngOnChanges(changes: SimpleChanges) {
        
    if ( !changes ) return
    
    if ( changes.visibleColumns && changes.visibleColumns.currentValue ){
      this.initCanvas()
    }

    if ( changes.rows && changes.rows.currentValue ){
      this.initCanvas()
    }
    
}


  canvas: any;
  ctx: any;

  chart: any
  oldWidth: number

  colorScale = d3.interpolateTurbo;

  colorRangeInfo = {
    colorStart: 0,
    colorEnd: 1,
    useEndAsStart: false,
  }; 

  initCanvas(): void {

    if (this.chart){
      this.chart.destroy() 
    }

    if (!this.rows || !this.visibleColumns || this.rows.length <= 0 || this.visibleColumns.length <= 0) {
      this.chart = null
      return
    }


    const labels  = this.extractLabels ()
    if (!labels || labels.length <= 0) {
      this.chart = null
      return
    }
    const dataSet = this.extractDatasets()
    var COLORS = this._utils.color().interpolateColors(dataSet.length, this.colorScale, this.colorRangeInfo);
    
    if (!dataSet || dataSet.length <= 0) {
      this.chart = null
      return
    }

    dataSet.forEach((dataset, i )=> {
      dataset.backgroundColor = COLORS[i]
      dataset.hoverBackgroundColor = COLORS[i]
    })
    console.log( dataSet );
    
    this.canvas = document.getElementById(this.conf.id);
    this.ctx = this.canvas.getContext('2d');

    const addOn: any = {}

    if ( this.conf.scales ) {
      addOn.scales = this.conf.scales
    }
    if ( this.conf.tooltips ) {
      addOn.tooltips = this.conf.tooltips
    }

    this.chart = new Chart(this.ctx, {
      type: this.conf.type,
      data: {
        labels  : labels ,
        datasets: dataSet
      },
      options: {
        legend: {
          display: this.conf.labels.isColumn
        },
        responsive: true,
        aspectRatio: window.innerWidth < 700 ? 1/2 : null,
        onResize: () => {
          this.updateChart ( )
        },
        ...addOn
      }
    });
  }

  updateChart () {
    const width = window.innerWidth
    if (      this.oldWidth >= 700 && width <= 700
          ||  this.oldWidth <= 700 && width >= 700  )
    this.initCanvas()

    this.oldWidth = width
  }

  extractLabels () {
    let labels: string[] = []
    const columns = this.conf.columns
    if(!columns             ) return []
    if(!this.visibleColumns ) return []
    columns.forEach( (column) => {

      let col = this.visibleColumns.find((visCol) => visCol.label == column.label)
      if (col){
        try {
          const label = this._translate.instant(column.name);
          labels.push ( label )
        } catch(error){}  
      } 
    })
    return labels
  }

  getRowsIndexes () {
    let indexes: number[] = []
    const columns = this.conf.columns
    if(!columns             ) return []
    if(!this.visibleColumns ) return []
    columns.forEach( (column) => {

      let index = this.visibleColumns.findIndex( visCol => visCol.label == column.label)
      if (index){
          indexes.push ( index + 1)
      } 
    })
    return indexes
  }

  getlabelIndex () {
    const columns = this.unfilteredColumns
    if(!columns                   ) return null
    if(!this.conf.labels.isColumn ) return null
    
    return columns.findIndex( (column) => column.label == this.conf.labels.name)
  }

  extractDatasets() 
  {
    let dataSets: any[] = []    
    const columns = this.conf.columns
    if(!columns             ) return []
    if(!this.visibleColumns ) return []

    const labelIndex = this.getlabelIndex()

    const indexes = this.getRowsIndexes()
    if(!this.rows) return []
    let pos = 0
    this.rows.forEach((row) => {
      const dataSet = this.createDataset(labelIndex, row, indexes)
      if (dataSet)  dataSets.push (dataSet) 
    })
    return dataSets
  }

  createDataset ( labelIndex: number, row: any[], indexes: number[]) {
    return {
      label: this.getLabel(labelIndex, row),
      data: this.extractData(row, indexes),
      borderWidth: 1
    }
  }

  extractData(row: any[], indexes: number[]){
    let dataset = []
    indexes.forEach( (i) => {            
      dataset.push( this.pipeColumn( this.conf.columns[i] , row[i]) )
    })
    return dataset
  }

  getLabel(labelIndex: number, row: any[]){
    if (!labelIndex) return null
    return row[labelIndex]
  }


  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 

  pipeColumn ( column: CustomColumn, value: any ) {        
    if ( !column || ! column.pipe ) return value
    const piped = column.pipe(value)
    return piped
  }

  // = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = 

  getLabels(  ) {
    if ( ! this.conf.labels.isColumn ) return []

  }
}
